"use client";
import React, { useEffect, useState } from "react";
import { Search, Menu as MenuIcon } from "react-feather";
import HeaderSocial from "./header-social";
import SearchBar from "./search/search-bar";
import Subscribe from "./subscribe";
import Drawer from "./drawer";
import CurrentDate from "./current-date";
import Button from "../ui/button";
import Menu from "./menu"
import MobileMenu from "./mobile-menu"
import Marquee from 'react-fast-marquee';
import parse from "html-react-parser";
import Link from "next/link";

export function Header({ siteData }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState(false);
  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
  const [isSubscribeDrawerOpen, setIsSubscribeDrawerOpen] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const subscribedEmail = localStorage.getItem('subscribedEmail');
    if (subscribedEmail) {
      setIsSubscribed(true);
    }
  }, []);

  const filteredPosts = siteData.postsData.filter((post) =>
    post.title.rendered.toLowerCase().includes(searchQuery.toLowerCase()) ||
    post.content.rendered.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleSearchDrawer = () => {
    setIsSearchDrawerOpen(!isSearchDrawerOpen);
    document.documentElement.classList.add("search-open");
  };
  const toggleMenuDrawer = () => {
    setIsMenuDrawerOpen(!isMenuDrawerOpen);
    document.documentElement.classList.add("subscribe-open");
  };

  const toggleSubscribeDrawer = () => {
    setIsSubscribeDrawerOpen(!isSubscribeDrawerOpen);
    document.documentElement.classList.add("subscribe-open");
  };

  const closeSearch = () => {
    setIsSearchDrawerOpen(false);
    document.documentElement.classList.remove("search-open");
    setSearchQuery("")
  };

  const closeMenu = () => {
    setIsMenuDrawerOpen(false);
    document.documentElement.classList.remove("subscribe-open");
  };

  const closeSubscribe = () => {
    setIsSubscribeDrawerOpen(false);
    document.documentElement.classList.remove("subscribe-open");
  };

  return (
    <header>
      <div className="container mx-auto px-3 md:px-0 py-3 md:py-5 flex items-end gap-4 xl:gap-10 justify-between">
        <div className="flex items-end gap-6 lg:gap-20">
          <a href="/" className="w-12 h-12 md:w-24 md:h-24 relative">
            <img
              src={"data:image/png;base64,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"}
              alt="The Independent Logo"
              className="w-12 h-12 md:w-24 md:h-24"
            />
          </a>
          <div className="flex gap-2 md:relative absolute top-4 left-4 md:top-0 md:left-0">
            <CurrentDate />
          </div>
        </div>
        <div className="flex flex-1 flex-col justify-end items-end gap-4">
          <div className="flex space-x-4 md:mt-4">
            <div onClick={toggleSearchDrawer} className="cursor-pointer">
              <Search size={18} stroke="#fff" strokeWidth={1} />
            </div>
            <HeaderSocial />
          </div>
          <div className="w-full border-b border-gray-800"></div>
          <div className="flex items-center gap-4"></div>
          <div className="flex items-center gap-4">
            <div onClick={toggleMenuDrawer} className="cursor-pointer font-slab flex items-center gap-2">
              Menu <MenuIcon size={24} stroke="#fff" strokeWidth={1.5} />
            </div>
            {!isSubscribed && (
              <Button onClick={toggleSubscribeDrawer} className="bg-red-500 text-white px-6 py-1 text-sm rounded-full hover:bg-red-600">
                Subscribe
              </Button>
            )}
          </div>
        </div>
      </div>
      {/* <div className="hidden md:block">
        <Menu />
      </div> */}
      <div className="container mx-auto">
        <div className="bg-red-500 text-white py-3 px-4 relative" style={{ height: '48px' }}>
          <div className="absolute left-0 top-0 bg-white text-black bottom-0 flex items-center justify-center z-10 px-6 ">
            <h4 className="text-black font-bold letter-spacing-wider">SG News <span className="right-angle"></span></h4>
          </div>
          <Marquee
            speed={100}
            gradient={false}
            pauseOnHover={true}
          >
            {siteData?.postsData
              ?.filter(post =>
                post.categories_with_names?.some(cat =>
                  cat.name === "Singapore News"
                )
              )
              ?.map((post) => (
                <span key={post.id} className="mx-4">
                  <Link href={`/${post.slug}`} className="hover:underline text-white">
                    {parse(post?.title?.rendered || "")}
                  </Link>
                  {" • "}
                </span>
              ))}
          </Marquee>
        </div>
      </div>
      <Drawer
        isOpen={isMenuDrawerOpen}
        onClose={closeMenu}
      >
        <MobileMenu
          isOpen={isMenuDrawerOpen}
          onClose={closeMenu}
        />
      </Drawer>
      <Drawer
        isOpen={isSearchDrawerOpen}
        onClose={closeSearch}
      >
        <SearchBar
          isOpen={isSearchDrawerOpen}
          closeSearch={closeSearch}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          filteredPosts={filteredPosts}
          popularCategories={siteData?.topTenCategories}
          allPosts={siteData?.postsData}
        />
      </Drawer>
      <Drawer
        isOpen={isSubscribeDrawerOpen}
        onClose={closeSubscribe}
      >
        <Subscribe
          isOpen={isSubscribeDrawerOpen}
          isClose={closeSubscribe}
        />
      </Drawer>
    </header>
  );
}
